import React from "react";
import { Plus } from "lucide-react";
import { INK_3, LINE_2 } from "../../Bureau/bureauTokens";

// .pl-legend-add — même coquille que AddCollaboratorButton.jsx, sans
// recherche : ouvre directement RoomsManagerModal (gestion des salles).
function ManageRoomsButton({ onClick }) {
  return (
    <button
      onClick={onClick}
      title="Gérer les salles"
      className="flex items-center justify-center"
      style={{ width: 26, height: 26, borderRadius: "50%", border: `1px dashed ${LINE_2}`, color: INK_3, background: "#fff" }}
    >
      <Plus size={13} />
    </button>
  );
}

export default ManageRoomsButton;
